// extracted by mini-css-extract-plugin
export default {"container":"_01_Header_container__+JoLw","value":"_01_Header_value__XberN"};